import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import router from './router'
import store from './store'
import 'amfe-flexible'
import './assets/style/animate.css'
import 'element-ui/lib/theme-chalk/index.css'
import AOS from 'aos'
import '../node_modules/aos/dist/aos.css'
// import VueLazyload from 'vue-lazyload'
Vue.config.productionTip = false
Vue.prototype.$EventBus = new Vue()
Vue.use(ElementUI)
Vue.use(AOS)
// Vue.use(VueLazyload)
document.oncontextmenu = function (evt) {
  evt.returnValue = false
  evt.stopPropagation()
  evt.preventDefault()
}
document.onselectstart = function (evt) {
  evt.preventDefault()
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
